import _ from 'lodash';
import store from '../store';


export const requireAuth = (roles = []) => (nextState, replace) => {
  const { auth } = store.getState();
  // auth.user.roles = ['user', 'admin']; //It should come from serverside or token and will be validated serverside too.

  // console.log(auth);
  if (roles.length === 0) return;

  if (auth.isAuthenticated) {
    if (_.isString(auth.user.roles) || _.isString(auth.user.role)) {
      if (roles.indexOf(auth.user.roles) !== -1 || roles.indexOf(auth.user.role) !== -1) { return; }
    }
  }

  if (auth.isAuthenticated) {
    if (_.isArray(auth.user.roles)) {
      if (_.intersection(roles, auth.user.roles)) { return; }
    }
  }
  /* eslint-disable consistent-return */
  return replace({
    pathname: '/',
    state: { nextPathname: nextState.location.pathname },
  });
};

/* eslint-disable consistent-return */
export const onlyNotAuthenticated = () => (nextState, replace) => {
  const { auth } = store.getState();
  // auth.user.roles = ['user', 'admin']; //It should come from serverside or token and will be validated serverside too.
  const { rel } = nextState.params;
  if (auth.isAuthenticated&&!rel) {
    console.log('auth', auth, 'why is this not hitting?');
    return replace({
      pathname: auth?.user?.role === 'brand' ? '/portal' : '/quests',
      state: { nextPathname: nextState.location.pathname },
    });
  }
};


export const inRoles = (roles = []) => {
  const { auth } = store.getState();
  // auth.user.roles = ['user', 'admin']; //It should come from serverside or token and will be validated serverside too.
  if (roles.length === 0) return false;

  if (auth.isAuthenticated) {
    if (_.isString(auth.user.roles) || _.isString(auth.user.role)) {
      if (roles.indexOf(auth.user.roles) !== -1 || roles.indexOf(auth.user.role) !== -1) { return true; }
    }
  }

  if (auth.isAuthenticated) {
    if (_.isArray(auth.user.roles)) {
      if (_.intersection(roles, auth.user.roles)) { return true; }
    }
  }

  return false;
};

export const isAuthenticated = () => {
  const { auth } = store.getState();
  return auth.isAuthenticated;
};

export const isAuthenticatedId = () => {
  const { auth } = store.getState();
  return auth.isAuthenticated ? auth.user.id : false;
};


export const checkAuthType = () => {
  const { auth } = store.getState();
  if (auth.isAuthenticated) {
    console.log('auth', auth, 'why is this not hitting?');
    return auth.user.role;
  }
  console.log('auth', auth, 'bbbbbbbbbbbbbbbbbbbbbbb');
  return auth.user.role;
};

export const inAdminPermissions = (functionName,regionName="") => {
  const { auth } = store.getState();
  //console.log('auth',auth);
  if (auth.isAuthenticated) {
    return isAdminHasPermission(auth.user,functionName,regionName);
  }

  return false;
};

export const isAdminHasPermission = (user,functionName,regionName="") => {
  let isHasPermission = false;
  if(user.permission&&user.permission.role){
    if(user.permission.role.name==='Super Admin'||!functionName){
      isHasPermission=true;
    }else if(user.permission.role.permissions&&user.permission.role.permissions.length>0){
      isHasPermission=user.permission.role.permissions.includes(functionName);
    }
  }
  let isHasRegion=false;
  if(user.permission&&user.permission.regions){
    if(!regionName){
      isHasRegion=true;
    }else if(user.permission.regions.length>0){
      isHasRegion=user.permission.regions.find(r=>r.name === regionName)?true:false;
    }
  }
  //console.log('isAdminHasPermission1',user,isHasPermission,isHasRegion,functionName,regionName);
  return isHasPermission&&isHasRegion;
};

export const inFinance = (user) => {
  return isAdminHasPermission(user,'ApproveWithdrawals','');
};

export const inSuperAdmin = () => {
  const { auth } = store.getState();
  if (auth.user&&auth.isAuthenticated) {
    return auth.user.permission && auth.user.permission.role && auth.user.permission.role.name === 'Super Admin';
  }
  return false;
};

export const requireAdminAuth = (functionName,regionName="") => (nextState, replace) => {
  const { auth } = store.getState();
  // auth.user.roles = ['user', 'admin']; //It should come from serverside or token and will be validated serverside too.
  if (auth.isAuthenticated) {
    if (Array.isArray(functionName)) {
      let isPermission = false;
      functionName.forEach(f => {
        if (isAdminHasPermission(auth.user, f, regionName)) {
          isPermission = true;
        }
      });
      return isPermission;
    } else {
      if (isAdminHasPermission(auth.user, functionName, regionName)) {
        return;
      }
    }
  }
  /* eslint-disable consistent-return */
  return replace({
    pathname: '/',
    state: { nextPathname: nextState.location.pathname },
  });
};

export const requireSuperAdminAuth = () => (nextState, replace) => {
  const { auth } = store.getState();
  // auth.user.roles = ['user', 'admin']; //It should come from serverside or token and will be validated serverside too.
  if (auth.isAuthenticated) {
    if (inSuperAdmin()) {
      return;
    }
  }

  /* eslint-disable consistent-return */
  return replace({
    pathname: '/',
    state: { nextPathname: nextState.location.pathname },
  });
};

